import React from "react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div className="mv-contact-page">

      <style>{`
        .mv-contact-page {
          min-height: calc(100vh - 100px);
          background: #fffaf4;
          color: #3b1f0e;
          font-family: "Lato", sans-serif;
        }

        .mv-contact-container {
          max-width: 1050px;
          margin: 0 auto;
          padding: 70px 24px 90px;
        }

        .mv-contact-hero {
          text-align: center;
          margin-bottom: 55px;
        }

        .mv-contact-eyebrow {
          color: #b77945;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 12px;
        }

        .mv-contact-title {
          font-family: "Playfair Display", serif;
          font-size: 48px;
          font-weight: 600;
          color: #3b1f0e;
          margin: 0 0 15px;
        }

        .mv-contact-title-line {
          width: 70px;
          height: 2px;
          background: #c9a063;
          margin: 0 auto 24px;
        }

        .mv-contact-intro {
          max-width: 760px;
          margin: 0 auto;
          color: #76553f;
          font-size: 16px;
          line-height: 1.8;
        }

        .mv-contact-divider {
          height: 1px;
          background: #e8d5c0;
          margin: 0 0 42px;
        }

        .mv-contact-section-title {
          font-family: "Playfair Display", serif;
          font-size: 30px;
          font-weight: 600;
          margin: 0 0 12px;
          color: #3b1f0e;
        }

        .mv-contact-section-text {
          font-size: 15px;
          color: #76553f;
          line-height: 1.7;
          margin: 0 0 28px;
        }

        .mv-contact-card {
          background: rgba(255,255,255,0.8);
          border: 1px solid #ead8c5;
          border-radius: 12px;
          padding: 30px 26px;
          box-shadow: 0 5px 25px rgba(80,45,20,0.05);
        }

        .mv-contact-row {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          margin-bottom: 22px;
        }

        .mv-contact-row:last-child {
          margin-bottom: 0;
        }

        .mv-contact-icon {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #fdf0e4;
          color: #92400e;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 16px;
        }

        .mv-contact-label {
          font-size: 12px;
          color: #9a7050;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 700;
          margin-bottom: 3px;
        }

        .mv-contact-value {
          font-size: 15px;
          color: #3b1f0e;
          line-height: 1.5;
        }

        .mv-contact-value a {
          color: #92400e;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .mv-contact-hours {
          margin-top: 42px;
          padding-top: 35px;
          border-top: 1px solid #e8d5c0;
        }

        .mv-hours-list {
          margin: 18px 0 0;
          padding-left: 22px;
          color: #76553f;
          line-height: 2;
          font-size: 15px;
        }

        .mv-contact-bottom {
          margin-top: 55px;
          text-align: center;
          padding: 40px 20px;
          border-radius: 14px;
          background: #f8eee4;
          border: 1px solid #ead8c5;
        }

        .mv-contact-bottom-title {
          font-family: "Playfair Display", serif;
          font-size: 25px;
          margin: 0 0 10px;
          color: #3b1f0e;
        }

        .mv-contact-bottom-text {
          color: #76553f;
          margin: 0 0 20px;
          line-height: 1.7;
        }

        .mv-contact-home-btn {
          display: inline-block;
          padding: 11px 25px;
          border-radius: 24px;
          background: #92400e;
          color: white;
          text-decoration: none;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: .3px;
          transition: .2s;
        }

        .mv-contact-home-btn:hover {
          background: #7c3510;
          transform: translateY(-1px);
        }

        @media (max-width: 650px) {
          .mv-contact-container {
            padding: 45px 18px 65px;
          }

          .mv-contact-title {
            font-size: 38px;
          }

          .mv-contact-intro {
            font-size: 14px;
          }

          .mv-contact-section-title {
            font-size: 26px;
          }

          .mv-contact-card {
            padding: 24px 18px;
          }
        }
      `}</style>

      <main className="mv-contact-container">

        {/* HERO */}

        <section className="mv-contact-hero">

          <div className="mv-contact-eyebrow">
            Mana Vastralu
          </div>

          <h1 className="mv-contact-title">
            Contact Us
          </h1>

          <div className="mv-contact-title-line" />

          <p className="mv-contact-intro">
            We’d love to hear from you! Whether you have
            questions about our sarees, orders, or
            collaborations — our team is here to assist you.
          </p>

        </section>

        <div className="mv-contact-divider" />

        {/* GET IN TOUCH */}

        <section>

          <h2 className="mv-contact-section-title">
            Get in Touch
          </h2>

          <p className="mv-contact-section-text">
            If you need support or have any enquiries,
            reach out to us through the details below.
          </p>

          <div className="mv-contact-card">

            {/* BUSINESS */}

            <div className="mv-contact-row">

              <div className="mv-contact-icon">
                🏷️
              </div>

              <div>
                <div className="mv-contact-label">
                  Business Name
                </div>

                <div className="mv-contact-value">
                  Mana Vastralu
                </div>
              </div>

            </div>

            {/* WEBSITE */}

            <div className="mv-contact-row">

              <div className="mv-contact-icon">
                🌐
              </div>

              <div>
                <div className="mv-contact-label">
                  Website
                </div>

                <div className="mv-contact-value">

                  <a
                    href="https://www.manavastralu.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.manavastralu.com
                  </a>

                </div>
              </div>

            </div>

            {/* EMAIL */}

            <div className="mv-contact-row">

              <div className="mv-contact-icon">
                ✉️
              </div>

              <div>
                <div className="mv-contact-label">
                  Email
                </div>

                <div className="mv-contact-value">
                  manavastralu.com
                </div>
              </div>

            </div>

            {/* PHONE */}

            <div className="mv-contact-row">

              <div className="mv-contact-icon">
                📞
              </div>

              <div>
                <div className="mv-contact-label">
                  Phone / WhatsApp
                </div>

                <div className="mv-contact-value">
                  +91 93909 05464
                </div>
              </div>

            </div>

            {/* LOCATION */}

            <div className="mv-contact-row">

              <div className="mv-contact-icon">
                📍
              </div>

              <div>
                <div className="mv-contact-label">
                  Location
                </div>

                <div className="mv-contact-value">
                Hyderabad, Telangana, India
                </div>
              </div>

            </div>

          </div>

        </section>

 

        {/* BOTTOM */}

        <section className="mv-contact-bottom">

          <h3 className="mv-contact-bottom-title">
            We’re Here to Help
          </h3>

          <p className="mv-contact-bottom-text">
            Thank you for choosing Mana Vastralu.
            We look forward to being part of your
            saree journey.
          </p>

          <Link
            to="/home"
            className="mv-contact-home-btn"
          >
            Explore Our Collection
          </Link>

        </section>

      </main>

    </div>
  );
}